import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { MatterManualTitleInsurance } from '@models/title-insurance';
import { TitlePlusStatus } from '@models/title-insurance';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';

export interface TitlePlusCancelModalData {
	status: TitlePlusStatus;
}

@Component({
	selector: 'app-title-plus-cancel-modal',
	templateUrl: './title-plus-cancel-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitlePlusCancelModalComponent {
	public TitlePlusStatus = TitlePlusStatus;
	public titleInsurance: MatterManualTitleInsurance;
	public submitted = false;
	public status: TitlePlusStatus;

	public ICON = ICON;

	@ViewSelectSnapshot(SelectedMatter.closingDate) closingDate: string;

	constructor(
		private dialogRef: MatDialogRef<TitlePlusCancelModalComponent>,
		@Inject(MAT_DIALOG_DATA) public _data: TitlePlusCancelModalData,
	) {
		this.status = _data.status;
	}

	cancel() {
		this.dialogRef.close(true);
	}

	close() {
		this.dialogRef.close(false);
	}
}
